import { type PropsWithChildren } from "react";
import { Navigate } from "react-router";
import { useTenants } from "../TenantsContext.tsx";

export interface RegionGateProps extends PropsWithChildren {
    redirectTo: string;
    shouldSkip?: boolean;
}

export function RegionGate({ children, redirectTo, shouldSkip = false }: RegionGateProps) {
    const hasRegion = useTenants().tenants?.region != null;

    if (!shouldSkip && !hasRegion) {
        return <Navigate to={redirectTo} replace />;
    }

    return children;
}
